import * as angular from "angular";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { Effort } from "../../models/effort.model";
import { SurveyService } from "../../services/survey.service";

let SurveyResultListComponent = {
    selector: "vcSurveyResultList",
    templateUrl: "/angular/components/survey/survey-result-list.component.html",
    bindings: {
        canvassType: "<",
    },
    controller: class SurveyResultsSectionController {
        // * bindings for typescript compiler *
        public canvassType: any;
        // ************************************

        private $scope: any;
        private service: SurveyService;
        private effortDataProvider: EffortDataProvider;

        public loading = true;
        public effort: Effort;
        public surveys: any;

        constructor(
            $scope: any,
            SurveyService: SurveyService,
            EffortDataProvider: EffortDataProvider
        ) {
            this.$scope = $scope;
            this.service = SurveyService;
            this.effortDataProvider = EffortDataProvider;

            this.effortDataProvider
                .getSelectedEffort()
                .then((effort: Effort) => {
                    this.effort = effort;
                    this.loadSurveys();
                });

            this.$scope.$watch(
                () => this.effort,
                (newValue: object, oldValue: object) => {
                    if (oldValue && newValue !== oldValue) {
                        angular.extend(this.effort, newValue);
                        this.loadSurveys();
                    }
                },
                true
            );
        }

        $onInit() {
            this.$scope.$watch(
                () => this.canvassType,
                (newValue: string, oldValue: string) => {
                    if (oldValue && newValue !== oldValue) {
                        this.loadSurveys();
                    }
                }
            );
        }

        loadSurveys(): void {
            this.loading = true;
            this.service
                .all({
                    category: this.canvassType,
                    effortid: this.effort.id,
                })
                .then((response: object) => {
                    const json = response["data"];
                    this.loading = false;
                    this.surveys = json.data;
                });
        }
    },
};

angular
    .module("survey")
    .component(SurveyResultListComponent.selector, SurveyResultListComponent);
